module.exports = __webpack_public_path__ + "img/horizontal_7_1_9005.a444bad4.png";